import React from 'react';
import { Clock, Facebook, Mail, MapPin, Phone, Star } from 'lucide-react';
import { company } from '../data/company';
import { QuoteCard } from './QuoteCard';
export function Quote() {
  return <section id="quote" className="bg-ink-soft" data-id="element-101" data-mp="1itdmwiwgxevl">
      <div className="mx-auto grid max-w-6xl gap-14 px-6 py-20 lg:grid-cols-[1fr_auto] lg:py-28" data-id="element-102" data-mp="1is2ajuoyiysv">
        <div className="max-w-lg" data-id="element-103" data-mp="1dukaktsx3tx0">
          <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-gold" data-id="element-104" data-mp="18vh3l3tdndme">
            <Star className="h-3.5 w-3.5 fill-gold" aria-hidden="true" data-id="element-105" data-mp="144h53u4m0nhs" />
            Free estimate
          </p>
          <h2 className="mt-5 text-3xl font-semibold tracking-tight text-white sm:text-4xl" data-id="element-106" data-mp="102m9n69d14bx">
            Tell us what needs cleaning.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-white/70" data-id="element-107" data-mp="v27znio77kb9">
            Send a few details and we'll get back to you within one business day.
            Prefer to talk it through? Call and JR will pick up.
          </p>

          <dl className="mt-10 space-y-5" data-id="element-108" data-mp="3fsb033f9nkfz">
            <div className="flex items-start gap-3" data-id="element-109" data-mp="3fr9q729zl3zu">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-110" data-mp="3kk2s7ie2ly88" />
              <div data-id="element-111" data-mp="35uwvq26mam41">
                <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/45" data-id="element-112" data-mp="35vg34oyn5s3t">
                  Call or text
                </dt>
                <dd className="text-sm font-semibold text-white" data-id="element-113" data-mp="3arnbeoeiffox">
                  <a href={company.phoneHref} className="hover:text-gold" data-id="element-114" data-mp="2f9b5fpl9jav">
                    {company.phone}
                  </a>
                </dd>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-115" data-mp="3ok4jqyq3db9s">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-116" data-mp="3onilc4qxlgg6" />
              <div data-id="element-117" data-mp="3tmc2q89c9rlm">
                <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/45" data-id="element-118" data-mp="2d5zfe4lyuzdx">
                  Email
                </dt>
                <dd className="break-all text-sm font-semibold text-white" data-id="element-119" data-mp="2i65cw1ex3g3x">
                  <a href={`mailto:${company.email}`} className="hover:text-gold" data-id="element-120" data-mp="omv6dd3gxkgp">
                    {company.email}
                  </a>
                </dd>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-121" data-mp="ew0ik4akqct5">
              <Clock className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-122" data-mp="eupe029b110z" />
              <div data-id="element-123" data-mp="9wxmvaghhixu">
                <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/45" data-id="element-124" data-mp="9vmmlkm8ytbh">
                  Hours
                </dt>
                <dd className="text-sm font-semibold text-white" data-id="element-125" data-mp="wj1kb3is3uc">{company.hours}</dd>
              </div>
            </div>
            <div className="flex items-start gap-3" data-id="element-126" data-mp="3s3vay3y5vczp">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-127" data-mp="3n48vroyrvmo9" />
              <div data-id="element-128" data-mp="1qbp7h17e1lwl">
                <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/45" data-id="element-129" data-mp="1qc8rcnglmkd9">
                  Based in
                </dt>
                <dd className="text-sm font-semibold text-white" data-id="element-130" data-mp="1ld5n358g0i6c">{company.base}</dd>
              </div>
            </div>
          </dl>

          <div className="mt-10 flex flex-wrap gap-6" data-id="element-131" data-mp="1xv878j4uptrv">
            <a href={company.google} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-gold" data-id="element-132" data-mp="1xtndgvqd2ev2">
              <Star className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="27mvx4flrf2r8" />
              Google profile
            </a>
            <a href={company.facebook} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-gold" data-id="element-134" data-mp="1ewdutgsv15ev">
              <Facebook className="h-4 w-4" aria-hidden="true" data-id="element-135" data-mp="1ovl4nu0dyhx8" />
              Facebook
            </a>
          </div>
        </div>

        <div className="lg:justify-self-end" data-id="element-136" data-mp="2vacewobeff3x">
          <QuoteCard data-id="element-137" data-mp="30973y7zylzwh" />
        </div>
      </div>
    </section>;
}